import { ClassAttributes, createElement } from 'react';

import { Organization } from '../../../graphql/generated/graphql';
import DummyContent from '../../component/primitive/DummyContent';
import OrganizationNameWithIcon from '../../component/primitive/OrganizationNameWithIcon';

type Props = ClassAttributes<HTMLElement> & {
  organization: Pick<Organization, 'name'> | undefined;
  loading: boolean;
  className?: string;
};

const OrganizationName = ({ organization, loading, className }: Props) => {
  if (loading || !organization) {
    return <DummyContent size="subtitle1" className={className} />;
  }

  return <OrganizationNameWithIcon name={organization.name || ''} className={className} />;
};

export default OrganizationName;
